// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#openMap[data-v-5176ec02] {\n  background: #fff;\n}\n.direction[data-v-5176ec02] {\n  position: absolute;\n  top: 35px;\n  right: 65px;\n  z-index: 99;\n}\n.direction .northImg[data-v-5176ec02] {\n  width: 40px;\n  height: 40px;\n  transform: rotate(-45deg);\n  margin-top: 10px;\n}\n#canvas[data-v-5176ec02] {\n  position: absolute;\n  left: 3%;\n  bottom: 2%;\n  z-index: 99;\n}", ""]);
// Exports
module.exports = exports;
